import {IColorChangeable} from '../../Interfaces';

declare let THREE: any;

export class Segment extends (THREE.Object3D as { new(): any; }) implements IColorChangeable {

  static readonly Name = 'Segment';
  private static verticalLineHalfSize = 10;

  constructor() {
    super();

    const material = new THREE.LineBasicMaterial({
      color: 0x000000
    });

    let geometry = new THREE.BufferGeometry().setFromPoints([
      new THREE.Vector3(0, 0, 0),
      new THREE.Vector3(1, 0, 0)
    ]);
    const horizontal = new THREE.Line(geometry, material);
    this.add(horizontal);

    geometry = new THREE.BufferGeometry().setFromPoints([
      new THREE.Vector3(0, 0, -Segment.verticalLineHalfSize),
      new THREE.Vector3(0, 0, 0),
      new THREE.Vector3(0, 0, Segment.verticalLineHalfSize)
    ]);
    const verticalLeft = new THREE.Line(geometry, material);
    this.add(verticalLeft);

    geometry = new THREE.BufferGeometry().setFromPoints([
      new THREE.Vector3(1, 0, -Segment.verticalLineHalfSize),
      new THREE.Vector3(1, 0, 0),
      new THREE.Vector3(1, 0, Segment.verticalLineHalfSize)
    ]);
    const verticalRight = new THREE.Line(geometry, material);
    this.add(verticalRight);

    this.name = Segment.Name;
  }

  update(startPoint, endPoint) {
    this.rotation.y = -Math.atan2(endPoint.z - startPoint.z, endPoint.x - startPoint.x);
    this.scale.x = endPoint.distanceTo(startPoint) || 1;
  }

  setColor(color): void {
    this.children.forEach(child => child.material.color.copy(color));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Dimensions/Segment.ts